module.exports = __webpack_public_path__ + "assets/img/opencard.f1ffbd8b.png";